import {
  schools,
  type AgeFilter,
  type School,
} from "../domain/data";

const AGE_OPTIONS: { value: AgeFilter; label: string }[] = [
  { value: "all", label: "All ages" },
  { value: "ms", label: "Middle school" },
  { value: "hs", label: "High school" },
];

function FilterSelect({
  id,
  label,
  value,
  onChange,
  options,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
}) {
  const current = options.find((option) => option.value === value)?.label ?? "";
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="select-shell">
        <span className="select-shell__value" aria-hidden="true">
          {current}
        </span>
        <svg
          className="select-shell__caret"
          viewBox="0 0 12 12"
          aria-hidden="true"
        >
          <path
            d="M2.25 4.25 6 8l3.75-3.75"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <select id={id} value={value} onChange={(event) => onChange(event.target.value)}>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export function DataFilters({
  age,
  onAge,
  school,
  onSchool,
  from,
  onFrom,
  to,
  onTo,
  showDates = false,
  onClear,
}: {
  age: AgeFilter;
  onAge: (value: AgeFilter) => void;
  school: School | "all";
  onSchool: (value: School | "all") => void;
  from?: string;
  onFrom?: (value: string) => void;
  to?: string;
  onTo?: (value: string) => void;
  showDates?: boolean;
  onClear: () => void;
}) {
  return (
    <div className="filters">
      <FilterSelect
        id="filter-age"
        label="Age"
        value={age}
        onChange={(value) => onAge(value as AgeFilter)}
        options={AGE_OPTIONS}
      />
      <FilterSelect
        id="filter-school"
        label="School district"
        value={school}
        onChange={(value) => onSchool(value as School | "all")}
        options={[
          { value: "all", label: "All districts" },
          ...schools.map((item) => ({ value: item, label: item })),
        ]}
      />
      {showDates ? (
        <>
          <div className="field">
            <label htmlFor="filter-from">From</label>
            <input
              id="filter-from"
              type="date"
              value={from ?? ""}
              onChange={(e) => onFrom?.(e.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="filter-to">To</label>
            <input
              id="filter-to"
              type="date"
              value={to ?? ""}
              onChange={(e) => onTo?.(e.target.value)}
            />
          </div>
        </>
      ) : null}
      <div className="field filters-clear">
        <span className="filters-clear-label">Filters</span>
        <button type="button" className="ghost" onClick={onClear}>
          Clear filters
        </button>
      </div>
    </div>
  );
}
